import type { MaintenanceTemplateVersionStatus } from '@gb-ticket/shared-types';

import { Badge } from '@/components/ui/badge';
import {
  maintenanceStatusBadgeClass,
  maintenanceStatusLabel,
  maintenanceTemplateVersionBadgeClass,
  maintenanceTemplateVersionLabel,
  type MaintenanceStatusInput,
} from '@/products/maintenance/features/maintenance-status';

type MaintenanceStatusBadgeProps =
  | { status: MaintenanceStatusInput; versionStatus?: never }
  | { status?: never; versionStatus: MaintenanceTemplateVersionStatus };

export function MaintenanceStatusBadge(props: MaintenanceStatusBadgeProps) {
  if ('status' in props && props.status !== undefined) {
    return (
      <Badge variant="outline" className={maintenanceStatusBadgeClass(props.status)}>
        {maintenanceStatusLabel(props.status)}
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className={maintenanceTemplateVersionBadgeClass(props.versionStatus)}>
      {maintenanceTemplateVersionLabel(props.versionStatus)}
    </Badge>
  );
}
